import ContributionCategoryModelBase from '../_generated/modelBases/contribution-category-model-base';

export default class ContributionCategoryModel extends ContributionCategoryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
